import { createApi } from "@reduxjs/toolkit/query/react";

import {
  baseQuery,
  PRODUCT_CERTS,
  PRODUCT_CERT,
  DELETE_PRODUCT_CERT,
  PROCESS_FILE_FOR_PRODUCT_CERT_WITH_CLIENT,
  UPDATE_PRODUCT_CERT_EXTRACTED_DATA,
} from "@/graphql";

export const certificateApi = createApi({
  reducerPath: "api/certificate",
  tagTypes: ["Certificates"],
  baseQuery,
  endpoints: (builder) => ({
    getProductCerts: builder.query<
      ProductCertsResponse["productCerts"],
      {
        clientId: string;
        pageNo?: number;
        pageSize?: number;
      }
    >({
      query: (variables) => ({
        document: PRODUCT_CERTS,
        variables: { ...variables },
      }),
      transformResponse: (response: ProductCertsResponse) =>
        response.productCerts,
      providesTags: ["Certificates"],
    }),
    getProductCert: builder.query<
      ProductCertResponse["productCert"]["data"],
      { id: string }
    >({
      query: (variables) => ({
        document: PRODUCT_CERT,
        variables: { ...variables },
      }),
      transformResponse: (response: ProductCertResponse) =>
        response.productCert.data,
      providesTags: (result) =>
        result ? [{ type: "Certificates", id: result._id }] : ["Certificates"],
    }),
    processFileForProductCert: builder.mutation<
      ProcessFileForProductCertResponse["processFileForProductCert"],
      { fileUrl: string; fileName: string; clientId: string; tenantId?: string; formType: string }
    >({
      query: (variables) => ({
        document: PROCESS_FILE_FOR_PRODUCT_CERT_WITH_CLIENT,
        variables: { ...variables },
      }),
      transformResponse: (response: ProcessFileForProductCertResponse) =>
        response.processFileForProductCert,
      invalidatesTags: ["Certificates"],
    }),
    deleteProductCert: builder.mutation<boolean, string>({
      query: (id) => ({
        document: DELETE_PRODUCT_CERT,
        variables: { id },
      }),
      transformResponse: (response: DeleteProductCertResponse) =>
        response.deleteProductCert.data,
      invalidatesTags: ["Certificates"],
    }),
    updateProductCertExtractedData: builder.mutation<
      UpdateProductCertExtractedDataResponse["updateProductCertExtractedData"]["data"],
      { id: string; extractedData: CertificateExtractedData }
    >({
      query: ({ id, extractedData }) => ({
        document: UPDATE_PRODUCT_CERT_EXTRACTED_DATA,
        variables: { id, extractedData },
      }),
      transformResponse: (response: UpdateProductCertExtractedDataResponse) =>
        response.updateProductCertExtractedData.data,
      invalidatesTags: (result) =>
        result ? [{ type: "Certificates", id: result._id }] : ["Certificates"],
    }),
  }),
});

export const {
  useGetProductCertsQuery,
  useGetProductCertQuery,
  useProcessFileForProductCertMutation,
  useDeleteProductCertMutation,
  useUpdateProductCertExtractedDataMutation,
} = certificateApi;